import { defineComponent as _defineComponent } from 'vue'
import { ref, Ref, computed } from "vue";
//@ts-ignore
import FormInput from "@/components/form/input.vue";
//@ts-ignore
import FormCombobox from "@/components/form/combobox.vue";
//@ts-ignore
import FormCheckbox from "@/components/form/checkbox.vue";
//@ts-ignore
import Submit from "@/components/form/submit.vue";
import * as Yup from "yup";
import { nl } from "yup-locales";
import { useErrors } from "@/utils/api-functions";
import { useApiStore, type WpProject, type WhiseUnit } from "@/stores/api";
//@ts-ignore
import EstateCard from "@/components/elements/whise-estate-card.vue";
//@ts-ignore
import ProjectCard from "@/components/elements/project-card.vue";
import { useForm } from "vee-validate";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/vue/solid";
import { breakpointsTailwind, useBreakpoints } from "@vueuse/core";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const apiStore = useApiStore();
const apiErrors = useErrors();

apiStore.getCities().then((c: string[]) => {
    cities.value = c.map((c) => {
        return { id: c, name: c };
    });
});

Yup.setLocale(nl);

const projects: Ref<WpProject[]> = ref([]);
const units: Ref<WhiseUnit[]> = ref([]);
const cities: Ref<Array<{ id: string | number; name: string }>> = ref([]);
const bedrooms = [
    { id: 1, name: "1+" },
    { id: 2, name: "2+" },
    { id: 3, name: "3+" },
    { id: 4, name: "4+" },
    { id: 5, name: "5+" },
];
const bathrooms = [
    { id: 1, name: "1+" },
    { id: 2, name: "2+" },
    { id: 3, name: "3+" },
    { id: 4, name: "4+" },
    { id: 5, name: "5+" },
];
const success = ref(false);
const loading = ref(true);
const currentPage = ref(0);
const total = ref(0);
const getData = (params: { bedrooms?: string; bathrooms?: string; for_sale?: boolean; for_rent?: boolean; city?: string[] } = {}) => {
    const promises = [];

    promises.push(apiStore.getWpProjects({ page: currentPage.value, per_page: 2, categories_exclude: [3], ...params }).then((e: WpProject[]) => (projects.value = e)));
    promises.push(
        apiStore.getWhiseUnits({ page: currentPage.value, per_page: 12, ...params }).then((e: any) => {
            units.value = e.data;
            total.value = e.total;
            currentPage.value = e.page;
        }),
    );

    Promise.all(promises).then(() => {
        loading.value = false;
        success.value = true;
    });
};
const componentKey = ref(0);
const breakpoints = useBreakpoints(breakpointsTailwind);
const isMobile = computed(() => breakpoints.isSmaller("lg"));

const getUrlQueryParameter = (name: string, fallback: any) => {
    const params = new URLSearchParams(window.location.search);

    if (params.has(name)) {
        return params.get(name);
    }

    return fallback;
};

const { handleSubmit, isSubmitting, resetForm, meta, values } = useForm({
    initialValues: {
        bedrooms: undefined,
        bathrooms: undefined,
        status: [],
        price_min: undefined,
        price_max: undefined,
        type: [],
        city: getUrlQueryParameter("city", "").split(",") || [],
    },
    validationSchema: Yup.object({
        bedrooms: Yup.string().optional(),
        bathrooms: Yup.string().optional(),
        city: Yup.array().optional(),
        status: Yup.array().optional(),
        type: Yup.array().optional(),
        price_min: Yup.number().optional(),
        price_max: Yup.number().optional(),
    }),
});

const open = ref(false);
const onSubmit = handleSubmit(async (values) => {
    try {
        success.value = false;
        loading.value = true;
        currentPage.value = 0;

        getData(JSON.parse(JSON.stringify(values)));

        updateUrlQueryParameters({ city: values.city });

        success.value = true;
        open.value = false;
    } catch (error) {
        apiErrors.parse(error);
    } finally {
        loading.value = false;
    }
});

const handleReset = async () => {
    await resetForm();

    componentKey.value += 1;
    currentPage.value = 0;
    getData();
};

const setPage = (page: number) => {
    currentPage.value = page;
    getData(JSON.parse(JSON.stringify(values)));
};

const updateUrlQueryParameters = (payload: { city?: any }) => {
    const params = new URLSearchParams(window.location.search);

    // clear all params
    params.delete("city");

    if (payload.city && payload.city.length > 0) {
        params.set("city", payload.city.join(","));
    }

    window.history.replaceState({}, "", `${window.location.pathname}?${params}`);
};

const zeroToThree = computed(() => units.value.slice(0, isMobile.value ? 4 : 3));
const ThreeToNine = computed(() => units.value.slice(isMobile.value ? 4 : 3, isMobile.value ? 10 : 9));
const NineToTwelve = computed(() => units.value.slice(isMobile.value ? 10 : 9, isMobile.value ? 13 : 12));
const firstProject = computed(() => (ThreeToNine.value.length > 0 ? projects.value[0] : null));
const secondProject = computed(() => (NineToTwelve.value.length > 0 ? projects.value[1] : null));

/** Wrapping up  */
getData({
    city: getUrlQueryParameter("city", "").split(",") || [],
});

const __returned__ = { apiStore, apiErrors, projects, units, cities, bedrooms, bathrooms, success, loading, currentPage, total, getData, componentKey, breakpoints, isMobile, getUrlQueryParameter, handleSubmit, isSubmitting, resetForm, meta, values, open, onSubmit, handleReset, setPage, updateUrlQueryParameters, zeroToThree, ThreeToNine, NineToTwelve, firstProject, secondProject, FormInput, FormCombobox, FormCheckbox, Submit, EstateCard, ProjectCard, ChevronDownIcon, ChevronUpIcon }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})